import { render, staticRenderFns } from "./standby.vue?vue&type=template&id=12ba95a5&lang=pug"
import script from "./standby.vue?vue&type=script&lang=js"
export * from "./standby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports